<template>
  <!--App政策-->
  <tk-container :status="status">
    <tkui-header center>
      <div slot="left-menu" @click="$back">
        <tkui-button class="icon">
          <tk-icon size="16">return</tk-icon>
        </tkui-button>
      </div>
      隐私查看
    </tkui-header>
    <!--列表-->
    <tkui-list class="p-x-12">
      <tkui-list-item
        disableHover
        @click.native="$push({ path: '/common/policyDetail', query: { type: 'userAgreement' } })"
      >
        用户声明
        <tk-icon size="12" :color="'#999999'" slot="right">rightarrow</tk-icon>
      </tkui-list-item>
      <tkui-list-item
        disableHover
        @click.native="$push({ path: '/common/policyDetail', query: { type: 'privacyPolicy' } })"
      >
        隐私政策
        <tk-icon size="12" :color="'#999999'" slot="right">rightarrow</tk-icon>
      </tkui-list-item>
    </tkui-list>
  </tk-container>
</template>

<script>
export default {
  data () {
    return {
      status: 'loading'
    }
  },
  mounted () {
    this.getInit()
  },
  beforeRouteLeave (to, from, next) {
    next(true)
  },
  methods: {
    async getInit () {
      try {
        this.setStatusBar('dark')
        this.status = false
      } catch (e) {
        this.status = 'error'
        this.$tkGlobal.toast.add('加载数据失败')
      }
    }
  }
}
</script>

<style scoped lang="scss">

</style>
